import * as log from 'loglevel';
import getterHelpers from '@/store/getter-helpers'; // TODO: Refactor to use getter as second argument of other getters

import {
  KARTENDESIGNER_VISIBLE,
  CARD_DATA_AS_JSON_STRING,
  FORMAT_ID,
  ACTIVE_THEME,
  ACTIVE_LAYER,
  ACTIVE_LAYER_TYPE,
  ACTIVE_LAYER_BOUNDING_CLIENT_RECT,
  ACTIVE_SIDE,
  ACTIVE_SIDE_ID,
  ACTIVE_LAYER_ID,
  ACTIVE_IMAGE_URL,
  USER_IMAGES,
  SIDES,
  SIDE_IDS,
  THEME_FONT_COLORS,
  THEME_COLORS,
  TOOLTIPS_VISIBLE,
  TOOLTIPS,
  LAYER_IS_FIRST_OF_TYPE,
  PREVIEW_VISIBLE,
  PREVIEW_IMAGE_FOR_SIDE_WITH_ID,
  PREVIEW_IMAGES_LOADED,
  // GET_IMAGE_LAYER_DPI_FOR_ACTIVE_LAYER,
  IS_PRINT_MODE,
  IS_SCREENSHOT_MODE,
  SHOP_URL,
  PRINT_SHOP_NOTES_BY_SIDE_ID,
  CARD_ID,
  SESSION_ID,
  WAITING_FOR_PDF,
  GET_TEXT,
  LAYOUT_MODE_ACTIVE,
  BLEED_AMOUNT,
  EDGE_USES_BLEED,
  IS_UNSUPPORTED_DEVICE_OR_RESOLUTION,
  SCALE,
  PAPER_ID,
  WINDOW_WIDTH,
  WINDOW_HEIGHT,
} from '@/store/getter-types';

export default {
  [KARTENDESIGNER_VISIBLE]: state => state.tmp.kartendesignerVisible,
  [CARD_DATA_AS_JSON_STRING]: state => JSON.stringify(state.card),
  /* TODO: This might just be called "id" in the spec. Update spec */
  [FORMAT_ID]: state => state.card.formatId,
  [ACTIVE_THEME]: state => state.card.themes.find(t => (t.id === state.card.activeThemeId)),
  [ACTIVE_LAYER_ID]: state => state.tmp.activeLayerId,
  [ACTIVE_LAYER_TYPE]: (state) => {
    const activeLayer = getterHelpers.getActiveLayer(state);
    if (activeLayer) {
      return activeLayer.type;
    }
    return null;
  },
  [ACTIVE_LAYER_BOUNDING_CLIENT_RECT]: state => state.tmp.activeLayerBoundingClientRect,
  [ACTIVE_LAYER]: (state) => {
    const activeSide = state.card.sides.find(c => c.id === state.tmp.activeSideId);
    if (!activeSide) { return null; }
    return activeSide.layers.find(l => l.id === state.tmp.activeLayerId);
  },
  [ACTIVE_SIDE]: state => state.card.sides.find(c => c.id === state.tmp.activeSideId),
  [ACTIVE_SIDE_ID]: state => state.tmp.activeSideId,
  [ACTIVE_IMAGE_URL]: (state) => {
    const activeSide = state.card.sides.find(c => c.id === state.tmp.activeSideId);
    if (!activeSide) { return null; }
    const activeLayer = activeSide.layers.find(l => l.id === state.tmp.activeLayerId);
    return activeLayer && activeLayer.imageUrl ? activeLayer.imageUrl : '';
  },
  [THEME_FONT_COLORS](state) {
    const activeTheme = getterHelpers.getActiveTheme(state);
    if (!activeTheme) {
      log.error('There is not active theme!');
      return [];
    }
    if (activeTheme.fontColors && activeTheme.fontColors.length > 0) {
      return activeTheme.fontColors;
    }
    log.error('Theme does not have font colors');
    return [];
  },
  [THEME_COLORS](state) {
    if (!state.card || !state.card.themes) { return []; }
    return state.card.themes.map(theme => ({ id: theme.id, color: theme.colorUi }));
  },
  [SIDES]: state => state.card.sides,
  // [GET_IMAGE_LAYER_DPI_FOR_ACTIVE_LAYER]: (state) => {
  //   const activeSide = getterHelpers.getActiveSide(state);
  //   if (!activeSide) { log.error('No active side'); }
  //   const sideWidth = activeSide.printWidth;
  //   const sideHeight = activeSide.printHeight;
  //   const activeLayer = getterHelpers.getActiveLayer(state);
  //   // // TODO: Implement, needed: Image dimensions / scale
  // },
  [SIDE_IDS]: state => state.card.sides.map(side => side.id),
  [TOOLTIPS_VISIBLE]: state => state.tmp.tooltipsVisible,
  [TOOLTIPS]: state => state.tmp.tooltips,
  [LAYER_IS_FIRST_OF_TYPE]: state => (layerId, layerType) => {
    const { layers } = getterHelpers.getActiveSide(state);
    for (let i = 0; i < layers.length; i += 1) {
      const layer = layers[i];
      if (layer.type === layerType) {
        if (layer.id === layerId) {
          return true;
        }
        return false;
      }
    }
    return false;
  },

  /*
    * Preview Getters
    */
  [PREVIEW_VISIBLE]: state => state.tmp.previewVisible,
  /* eslint-disable no-prototype-builtins */
  [PREVIEW_IMAGE_FOR_SIDE_WITH_ID]: state => (sideId) => {
    if (state.tmp.previewImages.hasOwnProperty(sideId)) {
      return state.tmp.previewImages[sideId];
    }
    return '';
  },
  [PREVIEW_IMAGES_LOADED]: state => state.tmp.previewImagesLoaded,

  /*
    * Image Upload Getters
    */
  [USER_IMAGES]: state => state.tmp.userImages,

  /*
   * Layout Mode Getters
   */
  [LAYOUT_MODE_ACTIVE]: state => state.tmp.layoutModeActive,

  /*
    * Other Getters
    */

  [IS_PRINT_MODE]: state => state.tmp.printMode,
  [IS_SCREENSHOT_MODE]: state => state.tmp.screenshotMode,
  [SHOP_URL]: state => state.card.shopUrl,
  [CARD_ID]: state => state.card.cardId,
  /**
   * Generates a map of notes for the print-shop. Contains some tips how the different pages
   * fit together.
   * @returns {Object} e.g. { front: 'note for front side', back: 'note for back side' }
   */
  /* eslint-disable arrow-body-style */
  [PRINT_SHOP_NOTES_BY_SIDE_ID]: (state) => {
    /* eslint-disable no-param-reassign */
    return state.card.sides.reduce((map, side) => {
      map[side.id] = side.printShopNote ? side.printShopNote : '';
      return map;
    }, {});
  },
  [SESSION_ID]: state => state.card.sessionId,
  [WAITING_FOR_PDF]: state => state.tmp.waitingForPdf,
  [GET_TEXT]: state => property => state.tmp.texts[property],
  [BLEED_AMOUNT]: state => state.card.bleedAmount,
  [EDGE_USES_BLEED]: state => (edge) => {
    const { useBleed } = getterHelpers.getActiveSide(state);
    if (!useBleed) { log.error('Could not find side.'); return false; }
    return useBleed[edge] ? useBleed[edge] : false;
  },
  [IS_UNSUPPORTED_DEVICE_OR_RESOLUTION]: state => state.tmp.isUnsupportedDeviceOrResolution,
  [SCALE]: state => state.tmp.scale,
  [PAPER_ID]: state => state.card.paperId,
  [WINDOW_WIDTH]: state => state.tmp.windowWidth,
  [WINDOW_HEIGHT]: state => state.tmp.windowHeight,
};
